/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  flexItem1: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  breadcrumbNavigation: Item<'BreadcrumbNavigation'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionShowMessage: Item<'ActionShowMessage'>;
} = {
  actionShowMessage: {
    children: [],
    itemId: 'actionShowMessage',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'expression',
        // eslint-disable-next-line no-template-curly-in-string
        value: '`You clicked ${$.bcndataAlias.name}`',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  breadcrumbNavigation: {
    children: ['triggerOnClick'],
    itemId: 'breadcrumbNavigation',
    parent: 'flexItem1',
    props: {
      comboDatasourceAlias: 'bcndataAlias',
      idAttribute: 'id',
      labelAttribute: 'name',
      padding: {
        bottom: 0,
        left: 20,
        right: 16,
        top: 0,
      },
      parentIdAttribute: 'parentId',
    },
    type: 'BreadcrumbNavigation',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'bcndataAlias',
    },
    type: 'DataStoreReference',
  },
  flexItem1: {
    children: ['breadcrumbNavigation'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem1'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'bcndataAlias',
      dataFormat: 'json',
      dataSource: 'bcndata',
      jsonData:
        '[\n    {\n        "name": "Level 1.1",\n        "id": "1.1",\n        "parentId": "1"\n    },\n    {\n        "name": "Level 1",\n        "id": "1"\n    },\n    {\n        "name": "Level 1.1.1",\n        "id": "1.1.1",\n        "parentId": "1.1"\n    },\n    {\n        "name": "Level 1.1.2",\n        "id": "1.1.2",\n        "parentId": "1.1"\n    },\n    {\n        "name": "Level 1.2",\n        "id": "1.2",\n        "parentId": "1"\n    },\n    {\n        "name": "Level 1.2.1",\n        "id": "1.2.1",\n        "parentId": "1.2"\n    },\n    {\n        "name": "Level 2",\n        "id": "2"\n    },\n    {\n        "name": "Level 2.1",\n        "id": "2.1",\n        "parentId": "2"\n    },\n    {\n        "name": "Level 2.1.1",\n        "id": "2.1.1",\n        "parentId": "2.1"\n    },\n    {\n        "name": "Level 2.1.2",\n        "id": "2.1.2",\n        "parentId": "2.1"\n    },\n    {\n        "name": "Level 2.2",\n        "id": "2.2",\n        "parentId": "2"\n    },\n    {\n        "name": "Level 2.2.1",\n        "id": "2.2.1",\n        "parentId": "2.2"\n    }\n]',
      singleton: true,
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  triggerOnClick: {
    children: ['actionShowMessage'],
    itemId: 'triggerOnClick',
    parent: 'breadcrumbNavigation',
    props: {},
    type: 'TriggerOnClick',
  },
};

export const helpRenders: ComponentSample<'BreadcrumbNavigation'>[] = [
  {
    title: 'Breadcrumb Navigation',
    page,
    exampleId: 'eg1',
    clearParentChildren: true,
    height: 480,
    visibleProps: [
      'padding',
      'idAttribute',
      'labelAttribute',
      'parentIdAttribute',
    ],
    item: {
      type: 'BreadcrumbNavigation',
      props: {
        padding: {
          top: 0,
          left: 20,
          right: 16,
          bottom: 0,
        },
        idAttribute: 'id',
        labelAttribute: 'name',
        parentIdAttribute: 'parentId',
        comboDatasourceAlias: 'bcndataAlias',
      },
      itemId: 'breadcrumbNavigation',
      parent: 'flexItem1',
      children: ['triggerOnClick'],
    },
  },
];
